import { Loader } from '@/components/ui'


const PageComponent: React.FC = () => {
  return <Loader/>
}

export default PageComponent
